import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ImageNonResponsive from "components/atoms/ImageNonResponsive";

import { transliterate, getQuizAnswers } from "utils/Language/LanguageAnalysis";
import "./styles.scss";

const QuizImage = (props) => {
  const [state, setState] = useState({
    quizAnswers: [],
    ...props,
  });

  useEffect(() => {
    setState({
      ...state,
      ...{
        quizAnswers: getQuizAnswers(state?.word, state?.exceptions),
        quizCunningMode: props?.quizCunningMode,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.quizCunningMode]);

  const toggleQuizCunningMode = () => {
    setState({
      ...state,
      ...{ quizCunningMode: !state?.quizCunningMode },
    });
  };

  const checkAnswer = (e, answer) => {
    if (
      state?.word?.toLowerCase().replace("1", "") ===
      answer?.toLowerCase()?.replace("*", "")
    ) {
      props?.next();
    } else {
      // TODO: Implement interaction
      console.log("Та ні, правильно не «" + answer + "»!");
    }
  };

  const cunningModeClass = state?.quizCunningMode ? "cunning-mode-on" : "";
  return state?.word ? (
    <ul className={`quiz-images ${cunningModeClass}`.trim()}>
      {state?.quizCunningMode && (
        <div
          className="cunning-mode-overlay"
          onClick={toggleQuizCunningMode}
          alt="Показати відповіді й ключі"
          title="Показати відповіді й ключі"
        />
      )}
      {state?.quizAnswers?.map((answer, index) => {
        const picturePath = transliterate(answer).replace("undefined", "");
        return (
          <li key={answer + index}>
            <ImageNonResponsive
              filename={`quiz/${picturePath}`}
              alt={answer.replace("*", "")}
              title={answer.replace("*", "")}
              onClick={(e) => checkAnswer(e, answer)}
            />
          </li>
        );
      }, this)}
    </ul>
  ) : null;
};

QuizImage.propTypes = {
  word: PropTypes.string,
  cunningMode: PropTypes.bool,
  toggleCardCunningMode: PropTypes.func,
};

export default QuizImage;
